// One presentation registry for primary model-line tags. Routing, labels,
// ordering, and descriptions remain Flarum data; this file owns only the
// stable visual assets required by Forum wayfinding.
// 2026-09-11: filenames follow the {family}-forum-nav/-forum-hero taxonomy
// (Model_Icon_Asset_Taxonomy_Abstract.md) - a rename-only pass for
// ami/traction/belphegor (pixels unchanged, byte-verified against the
// pre-rename files) plus a genuine content refresh for dsid, regenerated
// from the new v4 master (single side-view line art, replacing the old
// double-view v1/v2 drawing) via the same content-crop/transparency
// pipeline build_model_line_assets.py already used for ami/traction -
// dimensions below changed accordingly (was 460x322).
export default {
  dsid: {
    navigationIcon: 'citreg/category-icons/dsid-forum-nav.webp',
    railIdentityImage: 'citreg/category-icons/dsid-forum-nav.webp',
    discussionImage: 'citreg/category-icons/dsid-forum-hero.webp',
    discussionImageWidth: 460,
    discussionImageHeight: 143,
  },
  ami: {
    navigationIcon: 'citreg/category-icons/ami-forum-nav.webp',
    railIdentityImage: 'citreg/category-icons/ami-forum-nav.webp',
    discussionImage: 'citreg/category-icons/ami-forum-hero.webp',
    // 449x189, not dsid's 460x143 - the two derivatives were regenerated
    // 2026-08-30 to drop internal canvas padding (see
    // build_model_line_assets.py's own docstring), and Ami's source crop is
    // a genuinely flatter/wider silhouette than dsid's own hero reference,
    // not a mistake to reconcile to match it.
    discussionImageWidth: 449,
    discussionImageHeight: 189,
  },
  traction: {
    navigationIcon: 'citreg/category-icons/traction-forum-nav.webp',
    railIdentityImage: 'citreg/category-icons/traction-forum-nav.webp',
    discussionImage: 'citreg/category-icons/traction-forum-hero.webp',
    // Side-view crop from a findblueprints.com "Citroen 15 CV Traction
    // Avante 6 H Saloon Sedan, 1955" 3-view sheet, user-cropped from the
    // real download (925x314) rather than the site's own smaller preview
    // tier - chosen over the originally-staged 5-up silhouette sheet after
    // confirming that one's per-view resolution was well under what
    // ami/dsid were actually built from. Both figures are
    // build_model_line_assets.py's own measured output, 2026-09-05.
    discussionImageWidth: 460,
    discussionImageHeight: 151,
  },
  belphegor: {
    navigationIcon: 'citreg/category-icons/belphegor-forum-nav.webp',
    railIdentityImage: 'citreg/category-icons/belphegor-forum-nav.webp',
    discussionImage: 'citreg/category-icons/belphegor-forum-hero.webp',
    discussionImageWidth: 460,
    discussionImageHeight: 227,
    // Real primary-tag name is the short "N/P" (the truck's actual factory
    // type designation, N and P series) - too short/generic to work as
    // wayfinding on its own in a wider context like the breadcrumb trail,
    // where "Belphégor" (the well-known nickname) reads far better. This is
    // a deliberate, scoped exception to this policy's own "header text is
    // derived from the primary tag name, not a separate label map" rule
    // (Forum_Model_Line_Onboarding_Abstract.md) - user call, 2026-09-07:
    // the masthead stays tied to the tag's own short name ("N/P Forum");
    // the breadcrumb and the tag-selection dropdown (both of which have
    // room) use this instead.
    familyName: 'Belphégor',
    // v2 (2026-09-07): user reviewed the ChatGPT-generated line art at icon
    // scale and asked for 3 elements stripped for clarity - all the vehicle
    // lettering/placards, the roof ladder rack, and the externally-mounted
    // spare wheel at the rear. Removed via targeted white-fill regions on
    // the original 1786x881 source, then re-run through the same sealed-
    // outline flood fill used for v1's transparency.
    // v3 (2026-09-07, same day): user supplied a better-quality line-art
    // rendition (Blephegor_Side.png) that already omits the lettering,
    // ladder, and spare wheel - no manual cleanup needed, just the same
    // transparency pipeline and resize. v1/v2 files kept in Design Staging
    // for rollback; not otherwise referenced.
    // See Design Staging/Forum Visual Design/Citroen Line Drawing/Truck/.
  },
  // 2026-09-11: CX scaffolding, built ahead of any real manual (direct
  // instruction) - cx-master-v1.png is a dedicated master like DS/ID's own
  // (not a family-art reuse like ami/traction), generated via the same
  // plain default resize_contain() pipeline. No familyName override -
  // "CX" is already short and unambiguous, unlike Belphegor/N-P.
  cx: {
    navigationIcon: 'citreg/category-icons/cx-forum-nav.webp',
    railIdentityImage: 'citreg/category-icons/cx-forum-nav.webp',
    discussionImage: 'citreg/category-icons/cx-forum-hero.webp',
    discussionImageWidth: 460,
    discussionImageHeight: 152,
  },
};
